import { Transaction } from "@Safemate/Model/Transaction";
import { AppState } from "@Safemate/Store/types";
import * as React from "react";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import styled from "styled-components";
import { mapHeader, RowsPerPage, TranscationTable } from "./utils";
import { Pagination } from "react-bootstrap";
import { evaluatePositions } from "./Store/routines";
import { SetPage, setPage } from "./Store/actions";
import { CustomerSettings, CustomerSettingsContext } from "@Safemate/Store/settingsProvider";
import { isGx8 } from "@Safemate/DeviceHardwareEnum";

const HeaderWarning = styled.div`
  background: yellow;
  color: black;
  height: 75px;
  padding: 10px;
  font-weight: 700;
  margin: 10px 0px;
  border: black 2px solid;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  
  tr:nth-child(even) {
    background-color: ${props => props.theme.colors.backgroundPrimary};
  }

  tr:nth-child(odd) {
    background-color: inherit;
    }
    
    td, th {
      padding: 8px;
      }
      
  tr {
    height: 75px;
    border-bottom: ${props => props.theme.colors.border};
  }
`;

export const Tr = styled.tr<{alarm: boolean, notifyEvent: boolean, new: boolean}>`
  ${props => props.alarm && "cursor: pointer;"}
  background: ${props => 
    props.alarm 
      ? `${props.theme.tableColors.alarm } !important;`
      : props.notifyEvent
        ? `${props.theme.tableColors.notifyEvent} !important;`
        : props.new
          ? `${props.theme.tableColors.new} !important;` 
          : "inherit"};
`;

interface LogProps{
    transactions: Transaction[];
    dehaId: number;
    page: number;
    setPage: SetPage;
    details: boolean;
    showPosition: boolean;
    custId: number;
}

const mapStateToProps = ({ txLog: { transaction: { transactions, page, details, showPosition }, device: { device: { custId, dehaId }}} }: AppState) => {
    return{
        transactions,
        dehaId,
        page,
        details,
        showPosition,
        custId
    }
}

const mapDispatchToProps = {
  evaluatePositions,
  setPage
}

const Log = connect(mapStateToProps, mapDispatchToProps)(({ transactions, custId, dehaId, page, setPage, details, showPosition }: LogProps) => {

   const customerSettings = React.useContext(CustomerSettingsContext) as CustomerSettings;
  const settingsForCustomer = customerSettings[custId];

  let climaxConfig = false;
  if(settingsForCustomer){
    climaxConfig = settingsForCustomer.climaxConfig && isGx8(dehaId);
  }

  const { formatMessage } = useIntl();
  const start = (page - 1) * RowsPerPage;
  const end = start + RowsPerPage;

  const header = mapHeader(formatMessage, dehaId, details, showPosition);
  const displayedTransactions = transactions.slice(start, end);

  if(transactions.length === 0){
    return <div style={{padding: "15px"}}>{formatMessage({id: "noTransactions", defaultMessage: "Det er ingen transaksjoner for denne enheten"})}</div>
  };

  const totalRows = transactions.length;
  const totalPages = Math.ceil(totalRows / RowsPerPage);

  const handlePreviousPage = () => {
    setPage(Math.max(page - 1, 1));
  };

  const handleNextPage = () => {
    setPage(Math.min(page + 1, totalPages));
  };

  const goToPage = (page: number) => {
    setPage(page);
  };

  return(
    <>
    {climaxConfig && 
      <HeaderWarning>{formatMessage({id: "climaxConfigWarning", defaultMessage: "This device is connected to another SCAIP endpoint and may not show a complete log over all events"})}</HeaderWarning>
    }
    <Table>
      <thead>
        {header}
      </thead>
      <tbody>
        <TranscationTable transactions={displayedTransactions} detailed={details} showPosition={showPosition} />
      </tbody>
    </Table>
    {transactions.length > RowsPerPage &&
    <div style={{display: "flex", justifyContent: "center"}}>
      <Pagination>

        <Pagination.Prev 
          disabled={page === 1} 
          onClick={handlePreviousPage} 
        />

        {[...Array(totalPages)].map((_, i) => (
          <Pagination.Item
            key={i + 1}
            active={page === i + 1}
            onClick={() => goToPage(i + 1)}
          >
            {i + 1}
          </Pagination.Item>
        ))}

        <Pagination.Next 
          disabled={page === totalPages} 
          onClick={handleNextPage} 
        />

      </Pagination>
    </div>}
    </>
  )
})

export default Log;